// extracted by mini-css-extract-plugin
module.exports = {"header":"Base_header__13Bsx","link":"Base_link__2MV2F global_button__32dRo","content":"Base_content__24Mwq","logo":"Base_logo__TddEG"};